import locale from "./locales/en";
import { IFileWrapper } from "./types";

const basis = [
	"byte",
	"kilobyte",
	"megabyte",
	"gigabyte"
];
export function getBasis(size = 0, current = 0) {
	return size < 1024 ? size + " " + locale[basis[current]] : this.getBasis(Math.round(size / 1024), current + 1);
}

const MAX_WORD_LENGTH = 13;
export function truncateWord(word: string, len = MAX_WORD_LENGTH) {
	let start;
	let end;
	if (word.length <= len) {
		return word;
	}
	const dotIndex = word.lastIndexOf(".");
	if (dotIndex === -1) {
		end = word.substr(word.length - 4);
		start = word.substr(0, len - 7);
	} else {
		const endStartFrom = dotIndex - 3;
		end = word.substr(endStartFrom);
		start = word.substr(0, len - (word.length - endStartFrom));
	}
	return start + "..." + end;
}

export function calculateCover(image) {
	const {width, height} = image;

	const imageAspectRatio = width / height;

	let sHeight;
	let sWidth;
	let sx;
	let sy;

	if (imageAspectRatio > 1) {
		// width > height
		sWidth = height;
		sHeight = height;
		sx = (width - sWidth) / 2;
		sy = 0;
	} else if (imageAspectRatio < 1) {
		// width < height
		sWidth = width;
		sHeight = width;
		sx = 0;
		sy = (height - sHeight) / 2;
	} else {
		// width == height
		sHeight = width;
		sWidth = width;
		sx = 0;
		sy = 0;
	}
	return {
		sx,
		sy,
		sWidth,
		sHeight,
		dx: 0,
		dy: 0
	};
}

export enum FileType {
	image = "image",
	video = "video",
	archive = "archive",
	table = "table",
	document = "document",
	presentation = "presentation",
	application = "application",
	web = "web",
	apple = "apple",
	pdf = "pdf",
	psd = "psd",
	audio = "audio",
	other = "other",
	text = "text"
}

function getMimeAndExtension(fileWrapper) {
	const extension = fileWrapper.name.split(".").pop() || "none";
	const mime = fileWrapper.file ? fileWrapper.file.type : "";

	return {
		extension,
		mime
	};
}

export function getFileType(extension, mime) {
	switch(extension) {
		case "jpg":
		case "jpeg":
		case "gif":
		case "png":
		case "bmp":
		case "tiff":
		case "pcx":
		case "svg":
		case "ico":
			return FileType.image;
		case "avi":
		case "mpg":
		case "mpeg":
		case "rm":
		case "move":
		case "mov":
		case "mkv":
		case "flv":
		case "f4v":
		case "mp4":
		case "3gp":
		case "wmv":
		case "webm":
		case "vob":
			return FileType.video ;
		case "rar":
		case "zip":
		case "tar":
		case "tgz":
		case "arj":
		case "gzip":
		case "bzip2":
		case "7z":
		case "ace":
		case "apk":
		case "deb":
		case "zipx":
		case "cab":
		case "tar-gz":
		case "rpm":
		case "xar":
			return FileType.archive;
		case "xlr":
		case "xls":
		case "xlsm":
		case "xlsx":
		case "ods":
		case "csv":
		case "tsv":
			return FileType.table;
		case "doc":
		case "docx":
		case "docm":
		case "dot":
		case "dotx":
		case "odt":
		case "wpd":
		case "wps":
		case "pages":
			return FileType.document;
		case "wav":
		case "aiff":
		case "au":
		case "mp3":
		case "aac":
		case "wma":
		case "ogg":
		case "flac":
		case "ape":
		case "wv":
		case "m4a":
		case "mid":
		case "midi":
			return FileType.audio;
		case "pot":
		case "potm":
		case "potx":
		case "pps":
		case "ppsm":
		case "ppsx":
		case "ppt":
		case "pptx":
		case "pptm":
		case "odp":
			return FileType.presentation;
		case "html":
		case "htm":
		case "eml":
			return FileType.web;
		case "exe":
			return FileType.application;
		case "dmg":
			return FileType.apple;
		case "pdf":
		case "ps":
		case "eps":
			return FileType.pdf;
		case "psd":
			return FileType.psd;
		case "txt":
		case "djvu":
		case "nfo":
		case "xml":
			return FileType.text;
		default:
			const type = mime.split("/")[0];
			switch(type) {
				case "image":
					return FileType.image;
				case "audio":
					return FileType.audio;
				case "video":
					return FileType.video;
				default:
					return FileType.other;
			}
	}
}

export function getFileClassName(fileWrapper: IFileWrapper): string {
	const {mime, extension} = getMimeAndExtension(fileWrapper);

	return getFileType(extension, mime) + " extension-" + extension;
}

export function isImage(fileWrapper) {
	const {mime, extension} = getMimeAndExtension(fileWrapper);
	const fileType = getFileType(extension, mime);

	return fileType === FileType.image;
}